import { useSelector } from 'react-redux';

import Profile from '#src/components/Header/Profile/index.js';
import { isAuthenticated as authSelector } from '#src/store/session/selectors.js';
import Link from '#src/components/Link/index.js';

import styles from './LoginStatus.scss';

export function LoginStatus() {
  const isAuthenticated = useSelector(authSelector);
  return <div>{isAuthenticated ? <Profile /> : <LogInLink />}</div>;
}

function LogInLink() {
  return (
    <div>
      <span className={styles.extendedPrompt}>Already a member?</span>{' '}
      <Link className={styles.loginLink} id="navigation-login" to="/login">
        Log in
      </Link>
    </div>
  );
}
